import { useEffect, useRef, useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { Navigate, useParams } from 'react-router-dom'
import { Formik, FormikProps } from 'formik'

import {
  useAddImpact,
  useCheckImpactCodeExist,
  useImpact,
  useInitialImpactCode,
  useLibraryImpact,
} from 'src/hooks'
import { MainContainer, ImpactForm, HelperWrapper } from 'src/components'

import { ETranslationNs, IImpactForm } from 'src/types'
import { impactSchema } from 'src/common/validations'
import { initialFormState } from './form/state.form'
import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { generateFormState } from '../edit-impact/form/state.form'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'

const AddImpactScreen = () => {
  const { mutateAsync: addImpact, isSuccess, isLoading } = useAddImpact()
  const { accountId } = useParams()
  const theme = useTheme()
  const { data: impact, isLoading: isImpactLoading } = useImpact(DEFAULT_LANGUAGE_CODE)
  const { data: initialCode, isFetching: isCodeLoading } = useInitialImpactCode()
  const { data: libraryImpact, isLoading: isLibraryImpactLoading, refetch } = useLibraryImpact()
  const [isMeasurable, setIsMeausarble] = useState(false)
  const { mutateAsync: checkCodeTaken } = useCheckImpactCodeExist()
  const formikRef = useRef<FormikProps<IImpactForm>>(null)

  useEffect(() => {
    if (impact) {
      setIsMeausarble(
        !!(impact.quantity_type || impact.quantity || impact.period || impact.period_start),
      )
    }
  }, [impact])

  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  const handleFormSubmit = async (values: IImpactForm) => {
    if (formikRef.current) {
      const isCodeTaken = await checkCodeTaken(values.code)
      if (isCodeTaken && isCodeTaken.message) {
        formikRef.current.setErrors({ code: isCodeTaken.message })
        return
      }
    }

    await addImpact(values)
    await refetch()
  }

  const handleIsMeasurable = (val: boolean) => {
    setIsMeausarble(val)
  }

  if (isSuccess) {
    return <Navigate to={joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.IMPACTS)} />
  }

  if (isImpactLoading || isLibraryImpactLoading || isCodeLoading) return null

  return (
    <>
      {!isCodeLoading && (
        <MainContainer
          headerTitle={
            isLaptop ? (
              <HelperWrapper t="impacts-header-title-add" />
            ) : (
              <HelperWrapper t="impacts-header-title" ns={ETranslationNs.Navbar} />
            )
          }
          navigateBack
          withAccountIcon
          withScanBtn
        >
          <Formik
            innerRef={formikRef}
            initialValues={
              libraryImpact || impact
                ? generateFormState(libraryImpact ?? impact ?? libraryImpact!, initialCode!)
                : initialFormState(initialCode!)
            }
            validationSchema={impactSchema(isMeasurable)}
            validateOnBlur={false}
            onSubmit={handleFormSubmit}
          >
            <ImpactForm
              isLoading={isLoading}
              isAddingNew
              isMeasurable={isMeasurable}
              handleMeasurableUpdate={handleIsMeasurable}
            />
          </Formik>
        </MainContainer>
      )}
    </>
  )
}

export default AddImpactScreen
